import React, { useState, useEffect } from "react";

import Input from "components/Input";
import { translate } from 'react-i18next'; 

import {
  CloseIcon,
  Container,
  ContentWrapper,
  FigCaption,
  Frame,
  ImgWrapper,
  Wrapper,
  Img,
  Title,
} from './styles.js'

const Mood = ({handleOnClose, moodSelected, requiredMoodAction, setMoodSelected, setMoodMessage, moodModalTitle, t}) => {
  const [moods, setMoods] = useState([]);

  useEffect(() => {
    const moodInfos = JSON.parse(localStorage.getItem('USER_MOOD') || '{"user": {}, "mood": []}');
    const userMoodInfo = moodInfos.user;
    const localMoods = moodInfos.mood;
    const lastMoodId =  userMoodInfo.moodId;
    const lastMoodInLocalMoods = localMoods?.find((mood) => mood.id === lastMoodId);
    const selectedMoodId = lastMoodInLocalMoods ? lastMoodInLocalMoods.id : null;
    
    setMoodSelected(selectedMoodId);
    setMoods(localMoods);
  }, []);

  return (
    <Container>
      <TitleHandler requiredMoodAction={requiredMoodAction} handleOnClose={handleOnClose} moodModalTitle={moodModalTitle}/>
      {moods.length === 0 && (<Wrapper>{t('mood.moodNotFoundMsg')}</Wrapper>) }
      {
        moods.length > 0 &&
          (<>
            <ContentWrapper data-testid="mood-content-wrapper">
              {
                moods.map((props) => 
                  <Figure
                    selected={moodSelected}
                    setSelected={setMoodSelected}
                    key={`mood-${props.id}`}
                    {...props}
                  />
                )
              }
            </ContentWrapper>
            <Wrapper>
              <Input
                onChange={(event) => setMoodMessage(event.target.value)}
                placeholder={t('mood.conteMais')} spellCheck={true}
                margin="8px 0"
                data-testid="mood-input"
              />
            </Wrapper>
          </>)
      }
    </Container>
  );
}

const Figure = ({selected, setSelected, src, title, id}) => {
  return (
    <ImgWrapper
      onClick={() => setSelected(id)}
      selected={selected === id || selected === 0}
    >
      <Frame
        selected={selected === id}
      >
        <Img
          src={src}
          alt={title}
        />
      </Frame>
      <FigCaption>{title}</FigCaption>
    </ImgWrapper>
  );
}

const TitleHandler = ({requiredMoodAction, handleOnClose, moodModalTitle}) => {
  return (
    <Wrapper>
      <Title data-testid="mood-title">{moodModalTitle}</Title>
      {!requiredMoodAction && <CloseIcon onClick={handleOnClose}/>}
    </Wrapper>
  );
}

export default translate()(Mood);